import React, { useState } from "react"
import { graphql, StaticQuery } from "gatsby"
import Modal from "react-modal"
import { Form } from "react-final-form"
import isEmail from "validator/lib/isEmail"
import styled from "styled-components"
import { theme } from "Theme"
import Config from "Data"
import moment from "moment"
import { HeaderImage, FormHiddenFields, FormDebug, LoadingSpinner, Utils, Link } from "Components"
import { BasicInfo, StepsEventSelect, Spacer } from "Components/FormElements"
import FormNav from "./FormNav"
import StepWizard from "react-step-wizard"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

import {toast} from 'react-toastify'
const { colors, fontSize, fontFamily } = theme
const windowGlobal = typeof window !== "undefined" && window

function ValidateEmail(email) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  if (email.match(validRegex)) {
    return true
  } else {
    return false
  }
}

const emailblockReg =
  /^([\w]+@(?!gmail.com)(?!yahoo.com)(?!ymail.com)(?!hotmail.com)(?!msn.com)(?!aol.com)(?!live.com)(?!icloud.com)(?!me.com)([\w-]+\.)+[\w-]{2,4})?$/

const Container = styled.div`
  position: relative;
  padding: 1rem 1rem 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem 2rem 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const PrivacyLink = styled((props) => <Link {...props} />)`
  font-size: ${fontSize.smallish};
  padding: 1rem;
`

const FormFooter = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  flex-direction: column;
  border-top: 1px solid #ccc;
  button {
    line-height: initial;
    height: 36px;
    justify-content: center;
  }
`



const FormSponsorV3 = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const {
    events,
    showEvents,
    node,
    image,
    brand,
    title,
    subtitle,
    options,
    optionsLink,
    isOpen,
    closeModal,
    onAfterOpen,
    onRequestClose,
    onChangeInput,
  } = props

  let formData = {
    formName: "FormSponsor",
    origin: windowGlobal ? windowGlobal.location.href : "",
    retURL: "/thank-you",
    country: windowGlobal.country,
    brand: Config.brand,
    eventId: showEvents ? null : node ? node.id : "#",
    title: showEvents ? null : node ? `${node.events} | ${moment(node.date).format("MMM Do Y")}` : "#",
    mailingList: "sponsor_cxosync",
  }

  const toggleLoading = (e) => {
    setLoading(false);
  }

  const resetRecaptcha = (e) => {
    setCaptchaToken(false)
  }

  function postData(url = ``, data = {}, token = null) {
    return fetch(url, {
      method: "POST",
      mode: "no-cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrer: "no-referrer",
      body: JSON.stringify({ token, ...data }),
    })
      .then((response) => {
        response
          .json()
          .then((data) => {
            resetRecaptcha()
            if (data.retURL) {
              toast.success("Your request submitted successfully.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              windowGlobal.location = data.retURL
            } else {
              if (data?.msg?.trim()?.toLowerCase() == 'success') {
                toast.success("Your request submitted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              } else {
                toast.error("Something went wrong, Please try again later.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
              toggleLoading()
              onRequestClose()
            }
          })
          .catch(function (e) {
            console.error("handled the error")
            console.error(e)
          })
      })
      .catch((error) => console.error("Error:", error))
  }

  const onSubmit = async (values) => {
    // Check if the captcha was skipped or not : Parth Patel
    if (!executeRecaptcha) {
      return
    }
    // This is the same as grecaptcha.execute on traditional html script tags : Parth Patel
    const token = await executeRecaptcha('homepage')
    setLoading(true);
    postData(Utils.endpoints.referee, values, token).catch((error) => console.error(error))
  }

  const handleChange = (e) => {
    formData[e.target.name] = e.target.value
    setData(formData);
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          banners: bannersJson {
            banner {
              sponsor {
                childImageSharp {
                  gatsbyImageData(width: 1440, placeholder: BLURRED)
                }
              }
            }
          }
        }
      `}
      render={(data) => {
        const { banner } = data.banners

        return (
          <Modal
            id="modalSponsor"
            contentLabel="modalSponsor"
            closeTimeoutMS={400}
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            shouldFocusAfterRender={true}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
            shouldReturnFocusAfterClose={true}>
            {!loading && (
              <>
                {showEvents && (
                  <HeaderImage
                    title={`Sponsor ${Config.brand} Events`}
                    subtitle={`Interested in sponsoring ${Config.brand} events?`}
                    image={banner.sponsor}
                    optionsLink={optionsLink}
                    cta_url1_text={`Check pricing options here`}
                    cta_url1={`/options`}
                    target={`_blank`}
                  />
                )}
                {!showEvents && (
                  <HeaderImage
                    title={`${node ? `Sponsor ${node.events}` : `Sponsor ${Config.brand} Events`}`}
                    subtitle={node ? `${moment(`${node.date}`).format("dddd, MMMM Do, YYYY")}` : ""}
                    image={image ? image : banner.sponsor}
                    // venue={node && node.event.venue ? node.event.venue.venueName : ""}
                    optionsLink={optionsLink}
                    cta_url1_text={`Check pricing options here`}
                    cta_url1={`/options`}
                    target={`_blank`}
                  />
                )}

                <button className="btn-close" onClick={closeModal}>
                  X
                </button>
              </>
            )}

            <Container>
              {loading && <LoadingSpinner />}
              <Form
                initialValues={formData}
                onSubmit={onSubmit}
                validate={(values) => {
                  const errors = {}
                  if (!values.firstName) {
                    errors.firstName = "Required"
                  }
                  if (!values.lastName) {
                    errors.lastName = "Required"
                  }
                  if (!values.email) {
                    errors.email = "Required"
                  } else if (!isEmail(values.email)) {
                    errors.email = "Invalid email"
                  } else if (!ValidateEmail(values.email)) {
                    errors.email = "Not a Company email!"
                  }
                  if (!values.company) {
                    errors.company = "Required"
                  }

                  return errors
                }}
                render={({ form, handleSubmit, reset, submitting, pristine, values }) => (
                  <>
                    <div className="form">
                      <FormHiddenFields hiddenData={formData} />

                      <StepWizard isHashEnabled={false} nav={<FormNav />}>
                        <StepsEventSelect
                          events={events}
                          options={false}
                          // optionsLink={optionsLink}
                          showEvents={showEvents}
                        />
                        <BasicInfo
                          last={true}
                          disabled={submitting || pristine}
                          onClick={handleSubmit}
                          data-gtm={`Form Sponsor | Submit`}
                        // onLoadRecaptcha={this.onLoadRecaptcha}
                        // verifyCallback={this.verifyCallback}
                        />
                      </StepWizard>

                      <Spacer />

                      <FormFooter className="footerWrapper">
                        <PrivacyLink to={"/privacy/"} title={`Privacy policy`}>
                          Privacy policy
                        </PrivacyLink>
                      </FormFooter>
                    </div>

                    <FormDebug data={values}></FormDebug>
                  </>
                )}
              />
            </Container>
          </Modal>
        )
      }}
    />
  )
}


export default FormSponsorV3;